// extracted by mini-css-extract-plugin
export default {"classroomPageStylesWrapper":"classroomPageStyles_classroomPageStylesWrapper__7qXKD","classroomPageBodyWrapper":"classroomPageStyles_classroomPageBodyWrapper__AXXuA"};